import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "layout-main-content" };
const _hoisted_2 = {
    id: "main-content",
    ref: "mainContent",
    tabindex: "-1",
    class: "layout-main"
};
const _hoisted_3 = { class: "layout-footer" };
import { computed, useTemplateRef, onBeforeMount } from 'vue';
import { useSidebarStore } from '../stores/sidebar-store';
import OasisFooter from '../components/oasis-footer.vue';
import OasisHeader from '../components/oasis-header.vue';
import OasisSidebar from '../components/oasis-sidebar.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'oasis-layout',
    props: {
        screenTitle: {},
        curtinLogoUrl: {},
        siteLogoUrl: {},
        siteName: {},
        siteUrl: {},
        menu: {},
        isAuthenticated: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const stateStore = useSidebarStore();
        const headerRef = useTemplateRef('header');
        const mainContentRef = useTemplateRef('mainContent');
        const headerMenuContainer = computed(() => headerRef.value?.$el.querySelector('.header-menu'));
        const hasNav = computed(() => props.menu && props.menu.length > 0);
        const computedMenu = computed(() => props.menu?.map((item) => ({
            ...item,
            isExpanded: stateStore.readMenuState(item.label)
        })) ?? []);
        const updateMenuState = (value) => {
            const menuItem = computedMenu.value.find((m) => m.label === value.label);
            if (menuItem) {
                stateStore.updateMenuState(value.label, value.isExpanded);
            }
        };
        const skipToMainContent = () => {
            mainContentRef.value?.focus();
        };
        onBeforeMount(() => {
            if (props.isAuthenticated === false) {
                stateStore.reset();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["layout-container @container/layout", { 'no-nav': !hasNav.value }])
            }, [
                _createElementVNode("a", {
                    href: "#main-content",
                    class: "skip-to-content",
                    onClick: skipToMainContent
                }, "Skip to main content"),
                (hasNav.value)
                    ? (_openBlock(), _createBlock(OasisSidebar, {
                        key: 0,
                        class: "oasis-sidebar",
                        "toggle-container": headerMenuContainer.value ?? undefined,
                        "curtin-logo-url": _ctx.curtinLogoUrl,
                        "site-logo-url": _ctx.siteLogoUrl,
                        "site-name": _ctx.siteName,
                        "site-url": _ctx.siteUrl,
                        menu: computedMenu.value,
                        "onUpdate:state": updateMenuState
                    }, null, 8, ["toggle-container", "curtin-logo-url", "site-logo-url", "site-name", "site-url", "menu"]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(OasisHeader, {
                        ref: "header",
                        "has-nav": hasNav.value,
                        "is-authenticated": _ctx.isAuthenticated,
                        "site-url": _ctx.siteUrl,
                        class: "oasis-header"
                    }, null, 8, ["has-nav", "is-authenticated", "site-url"]),
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "default")
                    ], 512),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(OasisFooter, { "is-authenticated": _ctx.isAuthenticated }, null, 8, ["is-authenticated"])
                    ])
                ])
            ], 2));
        };
    }
});
